/** @format */
import localStorage from "local-storage";
import PersonIcon from "@mui/icons-material/Person";
import { Box, Button, Grid, Tooltip, Typography } from "@mui/material";
import { lighten } from "polished";
import moment from "moment";
import { Delete, Edit } from "@mui/icons-material";
const cellStyle = (params) => {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    whiteSpace: "nowrap", // Metnin taşmasını önler
    textOverflow: "ellipsis", // Taşan metin için ...
  };
};
const createColumnDefs = (onEdit, onDelete) => {
  return [
    {
      field: "title",
      filter: "agTextColumnFilter", // Doğru kullanım

      headerName: "Ünvan",
      width: 210,
      maxWidth: 250,

      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,
    },
    {
      field: "date",
      headerName: "Tarih",
      sortable: true,
      filter: false,
      maxWidth: 150,
      valueFormatter: (params) => {
        return moment(params.value).format("DD/MM/YYYY HH:mm");
      },
    },
    {
      field: "documentType",
      headerName: "İşlem Türü",
      sortable: true,
      filter: true,
    },
    {
      field: "description",
      headerName: "Açıklama",
      filter: "agTextColumnFilter", // Doğru kullanıms
      sortable: true,
      flex: 1,
    },
    {
      field: "expense",
      headerName: "Harcama",
      hide: true,
      sortable: true,
      filter: false,
      maxWidth: 110,
      valueFormatter: (params) => {
        return params.value.toFixed(2) + " ₺";
      },
      type: "numericColumn",
    },
    {
      field: "collection",
      headerName: "Alınan",
      sortable: true,
      filter: false,
      maxWidth: 110,
      valueFormatter: (params) => {
        return params.value.toFixed(2) + " ₺";
      },
      type: "numericColumn",
    },
    {
      field: "accrual",
      headerName: "Borç",
      sortable: true,
      filter: false,
      maxWidth: 110,
      valueFormatter: (params) => {
        return params.value.toFixed(2) + " ₺";
      },
      type: "numericColumn",
    },
    {
      field: "paymentType",
      headerName: "Ödeme Türü",
      sortable: true,
      filter: true,
      maxWidth: 120,
    },
    {
      headerName: "İşlemler",
      field: "actions",
      sortable: false,
      filter: false,
      width: 120,
      cellStyle: {
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      cellRenderer: (params) => {
        return (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => {
                console.log(params.data);
                onEdit(params.data);
              }}
              sx={{ minWidth: "40px", padding: "4px" }}
            >
              <Edit fontSize="small" />
            </Button>
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => onDelete(params.data.id)}
              sx={{ minWidth: "40px", padding: "4px" }}
            >
              <Delete fontSize="small" />
            </Button>
          </Box>
        );
      },
    },
  ];
};
export default createColumnDefs;
